import { createReducer } from 'typesafe-actions';
import exportsActions, { clearList } from './actions';
import { ExportsState, ExportsTypes } from './types';

export const INITIAL_STATE: ExportsState = {
  statements: [],
  isLoading: false,
  error: 0,
};

export type RootExportsActions =
  | ReturnType<typeof exportsActions.request>
  | ReturnType<typeof exportsActions.success>
  | ReturnType<typeof exportsActions.failure>
  | ReturnType<typeof clearList>;

const exportsReducer = createReducer<ExportsState, RootExportsActions>(
  INITIAL_STATE,
  {
    [ExportsTypes.ExportsRequest]: () => {
      return {
        ...INITIAL_STATE,
        isLoading: true,
      };
    },
    [ExportsTypes.ExportsSuccess]: (_, action) => {
      const { payload } = action;
      return {
        isLoading: false,
        error: 0,
        statements: payload.statements,
      };
    },
    [ExportsTypes.ExportsFailure]: (_, action) => {
      const { payload } = action;
      return {
        isLoading: false,
        error: payload,
        statements: [],
      };
    },
    [ExportsTypes.ClearExportsList]: () => {
      return INITIAL_STATE;
    },
  }
);

export default exportsReducer;
